import { ShieldCheck, Fingerprint, KeyRound, ServerCog } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, label: "25D Grade", sub: "Army-tier perimeter" },
  { icon: KeyRound, label: "AES-256", sub: "Sealed cipher" },
  { icon: Fingerprint, label: "Bio-Lock", sub: "Sovereign access" },
  { icon: ServerCog, label: "Node 0x7FA", sub: "Mesh redundancy" },
];

export default function SecurityBanner() {
  return (
    <section
      className="rounded-xl border border-white/5 bg-gradient-to-r from-black via-obsidian-surface to-black p-5 sm:p-6"
      data-testid="security-banner"
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-md border border-violet/30 grid place-items-center bg-violet/5">
            <ShieldCheck className="w-4 h-4 text-violet" />
          </div>
          <div>
            <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-violet-soft">
              Security Posture · LIVE
            </div>
            <div className="font-heading text-lg text-white mt-0.5">
              Army-Grade Perimeter Active
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 w-full sm:w-auto">
          {ITEMS.map(({ icon: Icon, label, sub }) => (
            <div
              key={label}
              className="flex items-center gap-2.5 px-3 py-2 rounded-md border border-white/5 bg-black/60"
              data-testid={`security-chip-${label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <Icon className="w-3.5 h-3.5 text-gold" />
              <div className="leading-tight">
                <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-white">
                  {label}
                </div>
                <div className="font-mono text-[9px] tracking-[0.18em] uppercase text-white/40">
                  {sub}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
